import React from "react";
import { InlineSkeleton } from "@smartling/react-skeleton";

import * as styles from "./skeleton.module.css";

export function ProductDescriptionSkeleton() {
    return (
        <div data-testid="productDescriptionSkeleton" className={styles.container}>
            <InlineSkeleton className={styles.heading} aria-label="Loading product description" />
            {Array.from({ length: 6 }).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <InlineSkeleton key={index} className={styles.bullet} />
            ))}
        </div>
    );
}
